import React from 'react';
import VideoOrImageContent from '../VideoOrImageContent/VideoOrImageContent';
import LinkContainer from '../LinkContainer/LinkContainer';

function SimpleBannerItem({ dataItem, contentGroupId }) {
  return (
    <div className="mn_simpleBannerItem" data-test="simple-banner-item">
      <LinkContainer dataItem={dataItem} contentGroupId={contentGroupId}>
        <VideoOrImageContent dataItem={dataItem} />
      </LinkContainer>
    </div>
  );
}

export default SimpleBannerItem;
